var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruckGreyIcon = function SvgTruckGreyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.326 5.75a2 2 0 0 1 1.79 1.106l2.673 5.347a2 2 0 0 1 .211.894v4.716a1 1 0 0 1-1 1h-.375a3.438 3.438 0 0 1-6.875 0h-5.5a3.438 3.438 0 0 1-6.875 0H2a1 1 0 0 1-1-1v-2.438h13.063V6.75a1 1 0 0 1 1-1h3.263Zm-.139 11.688a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75Zm-12.375 0a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75ZM11.688 3a1 1 0 0 1 1 1v10H1V4a1 1 0 0 1 1-1h9.688Zm6.529 4.813h-1.841a.25.25 0 0 0-.25.25v4.312c0 .138.112.25.25.25h3.804a.5.5 0 0 0 .46-.697l-1.504-3.51a1 1 0 0 0-.92-.605Z",
    id: "truck-grey-icon_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#7f8a99",
    xlinkHref: "#truck-grey-icon_svg__a",
    fillRule: "evenodd"
  })));
};
export default SvgTruckGreyIcon;